/** Same-origin /api fetches: always send session cookie (httpOnly token). */
export function pubFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  return fetch(input, { ...init, credentials: init?.credentials ?? 'include' })
}

/** Optional Bearer from localStorage; cookie is used when this is empty. */
export function authHeaders(): Record<string, string> {
  const t = localStorage.getItem('token')?.trim()
  if (!t) return {}
  const raw = t.replace(/^Bearer\s+/i, '').trim()
  return raw ? { Authorization: `Bearer ${raw}` } : {}
}

/** Clears httpOnly session cookie and localStorage auth. */
export async function logoutPublisherClient(): Promise<void> {
  try {
    await pubFetch('/api/auth/logout', { method: 'POST' })
  } catch {
    /* ignore */
  }
  localStorage.removeItem('token')
  localStorage.removeItem('user')
}
